import { createContext } from 'react';

export const FlatsTableListContext = createContext();
export const FlatsTableListActionsContext = createContext();
